export default "__VITE_ASSET__DqvGHaAk__"